import { IPolicyType } from "@/api";
import { Chip } from "@mui/material";

interface IProps {
    /**
     * Policy type to display.
     */
    policyType: IPolicyType;
    /**
     * Whether to display the short name.
     * @default false
     */
    shortName?: boolean;
}

/**
 * Display a policy type in a table cell.
 */
export const PolicyTypeCell = ({ policyType, shortName = false }: IProps) => {
    return (
        <Chip
            label={shortName ? policyType.short_name : policyType.name}
            size={"small"}
        />
    );
};
